<div [class.navigation--collapsed]="isCollapsed" class="navigation">
  <ng-content></ng-content>
</div>
